import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {asyncCreator} from "./sliceHelper"
import {WSObjectGroupSchedule} from "../types/WebSocketTypes"
import {objectGroupScheduleApi} from "../api/objectGroupScheduleApi"
import {ObjectGroupScheduleResponse, ObjectGroupSchedulesResponse} from "../models/response"

type InitialStateType = {
    schedules: null | ObjectGroupSchedulesResponse
    schedule: null | ObjectGroupScheduleResponse
    ws: WSObjectGroupSchedule | null
}

const initialState: InitialStateType = {
    schedules: null,
    schedule: null,
    ws: null,
}

export const objectGroupScheduleReducer = createSlice({
    name: 'objectGroupScheduleReducer',
    initialState,
    reducers: {
        setObjectGroupSchedules(state, {payload}) {
            state.schedules = payload
        },
        setObjectGroupSchedule(state, {payload}) {
            state.schedule = payload
        },
        addObjectGroupSchedule(state, {payload}) {
            if (state.schedules) {
                state.schedules = {
                    total: state.schedules.total += 1,
                    data: [payload, ...state.schedules.data],
                }
            }
        },
        editObjectGroupSchedule(state, {payload}: PayloadAction<ObjectGroupScheduleResponse>) {
            let index = state.schedules?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.schedules) state.schedules.data[index] = payload
            if (state.schedule) state.schedule = payload
        },
        setWSObjectGroupSchedule(state, {payload}: PayloadAction<WSObjectGroupSchedule | null>) {
            state.ws = payload
        },
    },
})

export const {setObjectGroupSchedules, setObjectGroupSchedule, addObjectGroupSchedule, editObjectGroupSchedule, setWSObjectGroupSchedule} = objectGroupScheduleReducer.actions

export default objectGroupScheduleReducer.reducer

export const getObjectGroupSchedules = asyncCreator
('objectGroupScheduleReducer/getObjectGroupSchedules', objectGroupScheduleApi.getSchedules, setObjectGroupSchedules)

export const getObjectGroupSchedule = asyncCreator
('objectGroupScheduleReducer/getObjectGroupSchedule', objectGroupScheduleApi.getSchedule, setObjectGroupSchedule)

export const createObjectGroupSchedule = asyncCreator
('objectGroupScheduleReducer/createObjectGroupSchedule', objectGroupScheduleApi.createSchedule, addObjectGroupSchedule)

export const changeObjectGroupSchedule = asyncCreator
('objectGroupScheduleReducer/changeObjectGroupSchedule', objectGroupScheduleApi.changeSchedule, editObjectGroupSchedule)

export const deleteObjectGroupSchedule = asyncCreator
('objectGroupScheduleReducer/deleteObjectGroupSchedule', objectGroupScheduleApi.deleteSchedule)